<template>
<div class="chapter">
<div class="inner_page">
<h2 class="h2b"><a id="page_xvii"><span class="bold">Map of operational areas</span></a></h2><a id="page_xvii">
<p class="image"><img alt="image" src="images/xvii-1.jpg"/></p>
</a><p class="caption"><a id="page_xvii">Map drawn by the author using a Rhodesia land tenure map from 1974 as a reference, which can be accessed at  <span class="weblink"></span></a><a href="http://www.rhodesia.me.uk" target="_blank"><span class="underline">www.rhodesia.me.uk</span></a>.</p>
<h3 class="h3"><span class="bold">Key – TTLs operating within Support Unit and Special Forces:</span></h3>
<p class="maps"><span class="maps_float">1.</span> Mangwende</p>
<p class="maps"><span class="maps_float">2.</span> Mudzi</p>
<p class="maps"><span class="maps_float">3.</span> Inyanga North</p>
<p class="maps"><span class="maps_float">4.</span> Wedza</p>
<p class="maps"><span class="maps_float">5.</span> Chiduku</p>
<p class="maps"><span class="maps_float">6.</span> Makoni</p>
<p class="maps"><span class="maps_float">7.</span> Manyika</p>
<p class="maps"><span class="maps_float">8.</span> Mutasa South</p>
<p class="maps"><span class="maps_float">9.</span> Gona re Zhou National Park</p>
<p class="maps"><span class="maps_float">10.</span> Mutumbara</p>
<p class="maps"><span class="maps_float">11.</span> Maranke</p>
<p class="maps"><span class="maps_float">12.</span> Matibi II</p>
<p class="maps"><span class="maps_float">13.</span> Diti</p>
<p class="maps"><span class="maps_float">14.</span> Chibi</p>
<p class="maps"><span class="maps_float">15.</span> Mpimbila</p>
<p class="maps"><span class="maps_float">16.</span> Gutsa</p>
<p class="maps"><span class="maps_float">17.</span> Centenary: Farming employment</p>
<p class="maps"><span class="maps_float">18.</span> Inyati: Uniform police work<a id="page_xviii"></a></p><a id="page_xviii">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 11_Maps.vue?30a0209c